import React from "react";
import {useSelector } from "react-redux";
import { buildFeeUnitPrices, calculateTotalWithFee, bookingFeeFixed, roundToTwoDecimals } from "../helpers/priceUtils";

const CheckoutPrice = () => {
    // state.price is the (possibly coupon-discounted) ticket total, ex fees.
    const price = useSelector(state => state.price);
    const fees = useSelector(state => state.tenant);
    const activeStation = useSelector(state => state.activeStation);
    const { seats } = useSelector(state => state.activeSeats);
    const travelers = useSelector(state => state.travelers);
    const train = useSelector(state => state.trains.currentTrain);

    // Same per-unit fee math as CalculatedPrice and the backend. A coupon shows
    // up as price < sum of units; the ratio scales each unit's fee accordingly.
    const unitPrices = buildFeeUnitPrices(travelers, activeStation, seats, train?.firstClassRate || 0);
    const undiscountedTotal = unitPrices.reduce((sum, unitPrice) => sum + unitPrice, 0);
    const discountRatio = undiscountedTotal > 0 ? price / undiscountedTotal : 1;

    const totalPrice = calculateTotalWithFee(price, unitPrices, fees, discountRatio);
    const ticketPrice = roundToTwoDecimals(totalPrice - bookingFeeFixed(fees));

    return (
        (price >= 0) &&
        <>
            <h3 className="text-gray-500 text-xs font-medium uppercase tracking-wide pt-4">Pris</h3>
            <div className="mt-3">
                <div className="text-lg font-semibold">
                    {totalPrice} kr <span className="text-xs font-normal">att betala inkl. moms</span>
                </div>
                <div className="text-sm text-gray-500 mt-1">
                    Biljettpris: {ticketPrice} kr inkl. moms
                </div>
                <div className="text-sm text-gray-500">
                    Bokningsavgift: {bookingFeeFixed(fees)} kr per bokning
                </div>
            </div>
        </>
    );
};

export default CheckoutPrice;
